.HeaderDropdown {
  position: relative;
}

.Trigger {
  display: inline-flex;
  align-items: center;
  min-height: 2.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  color: #111827;
  cursor: pointer;
  font-weight: 600;
  list-style: none;
}

.Trigger::-webkit-details-marker {
  display: none;
}

.Trigger::after {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.5rem;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  content: '';
  transform: translateY(-0.15rem) rotate(45deg);
  transition: transform 0.2s ease;
}

.HeaderDropdown[open] .Trigger::after {
  transform: translateY(0.1rem) rotate(225deg);
}

.Trigger:hover,
.Trigger:focus-visible {
  background: #f3f4f6;
  outline: none;
}

.Trigger:focus-visible,
.Item:focus-visible {
  box-shadow: 0 0 0 3px rgba(42, 143, 230, 0.35);
}

.Panel {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  z-index: 30;
  display: grid;
  width: min(22rem, calc(100vw - 2rem));
  gap: 0.25rem;
  padding: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
}

.Item {
  display: grid;
  grid-template-columns: 2.5rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  color: inherit;
  text-decoration: none;
}

.Item:hover {
  background: #f3f4f6;
}

.Icon {
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  place-items: center;
  border-radius: 0.5rem;
  background: #eff6ff;
  color: #2a8fe6;
}

.Icon img {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  object-fit: contain;
}

.Copy {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
}

.Title {
  color: #111827;
  font-weight: 700;
}

.Subtitle {
  color: #4b5563;
  font-size: 0.85rem;
  line-height: 1.35;
}
